import { render, staticRenderFns } from "./ScenicIndividualTicket.vue?vue&type=template&id=40661920&scoped=true"
import script from "./ScenicIndividualTicket.vue?vue&type=script&lang=js"
export * from "./ScenicIndividualTicket.vue?vue&type=script&lang=js"
import style0 from "./ScenicIndividualTicket.vue?vue&type=style&index=0&id=40661920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40661920",
  null
  
)

export default component.exports